import * as React from "react"
import * as styles from "./index.module.scss"
import classNames from "classnames";
import {Container} from "@/components";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  description?: string
}

const Banner: React.FC<IProps> = ({ className, children, description, ...props }) => {
  return (
    <div className={classNames(className, styles.container)} {...props}>
      <Container>
        <h1>{children}</h1>
        {description && <h5>{description}</h5>}
      </Container>
    </div>
  )
}

export default Banner
